// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g6EsOVKWmcp7SavtQ7rm{text-align:center;padding:15px;display:flex;flex-direction:column;height:100%}.g6EsOVKWmcp7SavtQ7rm .NTJpRprrOdNSHularcKc{color:var(--color-515-granat);font-size:16px;font-style:normal;font-weight:700;line-height:116.5%;margin-bottom:20px;flex:0 0 auto}.g6EsOVKWmcp7SavtQ7rm .lv1jIkz49U5VIZy02qST{color:var(--color-515-granat);text-align:center;font-size:14px;font-style:normal;font-weight:400;line-height:135%;margin-bottom:20px;flex:0 0 auto}.g6EsOVKWmcp7SavtQ7rm .YoewmSiDNFSbnZM3WARH{flex:1 1 0}.g6EsOVKWmcp7SavtQ7rm .YoewmSiDNFSbnZM3WARH>*{max-height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `g6EsOVKWmcp7SavtQ7rm`,
	"header": `NTJpRprrOdNSHularcKc`,
	"subheader": `lv1jIkz49U5VIZy02qST`,
	"contentWrapper": `YoewmSiDNFSbnZM3WARH`
};
export default ___CSS_LOADER_EXPORT___;
